// React Imports
import { useNavigate } from "react-router-dom";

// Component Imports
import ICONS from "../../../assets/Icons";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import ReimbursementTxnDetails from "../../../containers/ReimbursementTransactions/ReimbursementTxnDetails";

function ReimbursementTxnDetailsPopup({
  closePopup,
  account_txn_id,
  type,
  TransactionHeader,
}) {
  // 1️⃣ useNavigate
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle={TransactionHeader}
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        smallPopupHeader={"Are you sure you want to leave this page?"}
        headertextSize="font-md"
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closePopup();
          navigate(
            `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account_txn_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closePopup}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={true}
      >
        <ReimbursementTxnDetails
          bene_txn_id={account_txn_id}
          type={type}
          closeBeneTxnDetailModal={closePopup}
          isPopup
          typeMulti
          typeSingle
        />
      </LargePopupRedirect>
    </div>
  );
}

export default ReimbursementTxnDetailsPopup;
